import { Outlet } from "react-router";

import PageHeader from "#/components/PageHeader";

/**
 * Admin page layout.
 *
 */
export default function ProfileLayout() {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("profile.title")} backURL="/" />
      <Outlet />
    </div>
  );
}
